const REDUCER_PATH = "borrowerService";
const BORROWER_SERVICE_TAG = "Borrower";

const RELATED_TAGS = [BORROWER_SERVICE_TAG];

export { REDUCER_PATH, BORROWER_SERVICE_TAG, RELATED_TAGS };

